export const ImageSizes = {
  small: 32,
  medium: 44,
  large: 64,
  extraLarge: 96,
};

export const cameraSizes = {
  small: 16,
  medium: 24,
  large: 24,
  extraLarge: 24,
};
